import React from "react";
import { Grid, Card, CardMedia, Box } from "@mui/material";

const GalleryGrid = ({ images }) => (
    <Grid container spacing={2} justifyContent="center">

        {images.map((src, idx) => (
            <Grid item xs={6} sm={4} md={3} key={idx}>
                <Box
                    component="img"
                    src={src}
                    alt={`Gallery ${idx + 1}`}
                    sx={{
                        width: "100%",
                        height: { xs: 150, sm: 180, md: 200 },
                        objectFit: "cover",
                        borderRadius: 2,
                        display: "block",
                        mx: "auto",
                    }}
                />
            </Grid>
        ))}
    </Grid>
);

export default GalleryGrid;
